import React from 'react'
import * as S from './styles'

type PrescriptionDeliveryInformationCardProps = {
  fontSize?: 'sm' | 'md';
  gap?: string;
};

export function PrescriptionDeliveryInformationCard({
  fontSize = 'md',
  gap='30px'
}: PrescriptionDeliveryInformationCardProps): JSX.Element {
  return (
    <S.Container fontSize={fontSize} gap={gap}>
      <S.CustomTypography>
        <span>Importante: </span>
        Caso a medicação prescrita demande um tipo de receita especial (amarela
        ou azul), é necessária a via física. O envio físico da receita é
        opcional e pode ter um custo de R$13,90.
      </S.CustomTypography>
      <S.CustomTypography>
        <b>
          Ao prosseguir, você concorda com estes termos.&nbsp;
          <a
            href={process.env.REACT_APP_FAQ_PRESCRIPTION_URL}
            target="_blank"
          >
            Saiba mais.
          </a>
        </b>
      </S.CustomTypography>
    </S.Container>
  )
}
